document.getElementById('read-more-btn').addEventListener('click', function () {
    const content = document.querySelector('.read-more-content');
    const toggleBtn = this;

    if (content.style.display === 'none' || content.style.display === '') {
        content.style.display = 'block'; // Show content
        toggleBtn.textContent = 'Show Less'; // Update button text
    } else {
        content.style.display = 'none'; // Hide content
        toggleBtn.textContent = 'More Details'; // Update button text
    }
});
